class WrapperTextBlock extends HTMLElement {
  constructor() {
    super();

    this.HEIGHT_TYPES = {
      "nepal-content": 163,
      "social-content": 134,
      "cashmere-content": 163,
      "manufacture-content": 138,
      "family-content": 163,
    }

    this.MOBILE_HEIGHT = 109;
    this.maxHeight = 0;

    this.socialTopClipPath = 309; // 193
    this.manufactureTopClippath = 344; // 211

    this.block = this.querySelector('.paragraph-content-block');
    this.init = this._init.bind(this);
    this.resizeClipPath = this._resizeClipPath.bind(this);

    this.init();
  }

  _init() {
    const contentBlock = this.block
    this.resizeClipPath();

    const editorMode = (this.getAttribute('data-editor-is') === 'true');

    const id = contentBlock.getAttribute('id');
    const parentDiv = contentBlock.parentNode;
    const height = contentBlock.offsetHeight;
    this.maxHeight = editorMode ? 550 : height;
    const controlHeight = window.innerWidth > 640 ? this.HEIGHT_TYPES[id] : this.MOBILE_HEIGHT;

    if (height > controlHeight || editorMode) {
      contentBlock.style.overflow = 'hidden';
      contentBlock.classList.add('small-container');
      var button = document.createElement("div");
      button.classList.add('paragraph-show-more');
      button.textContent = "MEHR LESEN";
      button.setAttribute('id', id + '-button-more');
      button.setAttribute('data-type', id);
      button.addEventListener('click', this.showMore.bind(this));
      parentDiv.insertBefore(button, contentBlock.nextSibling);
    }
    
    window.addEventListener('resize', this.resizeClipPath)
  }

  _resizeClipPath() {

    const id = this.block.getAttribute('id');
    const containerTop = (this.getBoundingClientRect()).top;
    const blockTop = (this.block.getBoundingClientRect()).top;
    
    let clipSelector = null;
    let imageSelector = null;
    this.maxHeight = 500;

    if (id === 'social-content') {
      clipSelector = '#social-content-clip';
      imageSelector = '#social-image-for-clippath';
    }

    if (id === 'manufacture-content') {
      clipSelector = '#manufacture-content-clip';
      imageSelector = '#manufacture-image-for-clippath';
    }

    if (clipSelector && imageSelector) {
      const clipPath = this.querySelector(clipSelector);
      const imageContainer = this.querySelector(imageSelector);
      const imageTop = (imageContainer.getBoundingClientRect()).top;
      let clipPathHeight = (imageTop - containerTop) - (blockTop - containerTop);
      const imageHeight = (imageContainer.getBoundingClientRect()).height;
      clipPathHeight = clipPathHeight > 0 ? clipPathHeight : 0;
      clipPath.style.shapeOutside = 'polygon(0% '+ (clipPathHeight) +'px, 100% ' + clipPathHeight + 'px, 100% 100%, 0 100%)'
      clipPath.style.clipPath = 'polygon(0% '+ (clipPathHeight) +'px, 100% ' + clipPathHeight + 'px, 100% 100%, 0 100%)'
      clipPath.style.height = imageTop - blockTop + imageHeight + 10 + 'px'
    }
  }

  showMore(elem) {
    
    var content = document.getElementById(elem.target.getAttribute('data-type'));
    var clipPath = document.getElementById(elem.target.getAttribute('data-type') + '-clip');
    if (content) {
      if (content.classList.contains('show-more')) {
        content.style.removeProperty('max-height');
        
        if (clipPath) {
          setTimeout(function() {
            if (clipPath) {
              clipPath.classList.toggle('visible');
              content.style.overflow = 'hidden';
            }
          }, 550);
        }
      } else {
        if (clipPath) {
          content.style.overflow = 'initial';
          clipPath.classList.toggle('visible');
          content.style.maxHeight = (this.maxHeight + 100) + 'px';
        } else {
          content.style.maxHeight = this.maxHeight + 'px';
        }
      }
      elem.target.textContent = elem.target.textContent === "MEHR LESEN" ? "WENIGER LESEN" : "MEHR LESEN";
      content.classList.toggle('show-more');
    }
  }
}

customElements.define('wrapper-block', WrapperTextBlock);

